import type { ComponentPublicInstance } from 'vue';

export class ComponentError extends Error {
  readonly name = 'ComponentError';

  constructor(
    public readonly err: unknown,
    public readonly instance?: ComponentPublicInstance | null,
    public readonly info?: string,
  ) {
    super(err instanceof Error ? err.message : String(err));
  }
}
